import { render, staticRenderFns } from "./OtherFamily.vue?vue&type=template&id=76f1feec&scoped=true&"
import script from "./OtherFamily.vue?vue&type=script&lang=js&"
export * from "./OtherFamily.vue?vue&type=script&lang=js&"
import style0 from "./OtherFamily.vue?vue&type=style&index=0&id=76f1feec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f1feec",
  null
  
)

export default component.exports